import { PRODUCT_IDS } from "@chef/constants";
import { useProductsByIdsQuery } from "@chef/state-management";
import { isEqualStrings } from "@chef/utils/equal";
import { isOneSubProduct } from "@chef/helpers";

import type { RecursivePartial } from "@chef/types/utils";
import type { SignupSession } from "@chef/types/payment";

export const useSelectedProductAndVariationDetails = (
  signupSession?: RecursivePartial<SignupSession> | SignupSession,
) => {
  const week = signupSession?.basket?._meta?.week;
  const year = signupSession?.basket?._meta?.year;
  const variationId = signupSession?.basket?.items?.[0]?.variationId;

  const { data: productsByIdsQuery } = useProductsByIdsQuery(
    {
      productIds: [PRODUCT_IDS.ONESUB],
      week: week!,
      year: year!,
    },
    { skip: !week || !year || !variationId },
  );

  if (!signupSession || !variationId) {
    return {
      selectedProduct: null,
      selectedVariation: null,
    };
  }

  const oneSubProduct = productsByIdsQuery?.products.find(isOneSubProduct);

  const selectedVariation = oneSubProduct?.variations.find((variation) =>
    isEqualStrings(variation.variationId, variationId),
  );

  return { selectedProduct: oneSubProduct, selectedVariation };
};
